/**
 * Répliques de films — source : GQ France,
 * https://www.gqmagazine.fr/galerie/les-repliques-cultes-du-cinema
 * (userFullName = film et année, affiché sous la citation)
 */
export type LoaderQuote = {
    message: string;
    userFullName: string;
};

export const LOADER_QUOTES: readonly LoaderQuote[] = [
    { message: 'Mon nom est Bond, James Bond', userFullName: 'James Bond 007 contre Dr No (1962)' },
    {
        message: 'La vie, c’est comme une boîte de chocolats : on ne sait jamais sur quoi on va tomber',
        userFullName: 'Forrest Gump (1994)',
    },
    { message: 'Marcello ! Come here !', userFullName: 'La Dolce Vita (1960)' },
    {
        message: 'Madame Robinson, vous essayez de me séduire, n’est-ce pas ?',
        userFullName: 'Le Lauréat (1967)',
    },
    {
        message: 'Spartiates ! Mangez avec appétit, car ce soir, nous dînerons en enfer !',
        userFullName: '300 (2006)',
    },
    {
        message: 'Un grand pouvoir implique de grandes responsabilités.',
        userFullName: 'Spider-Man (2002)',
    },
    { message: 'Sssplendide !', userFullName: 'The Mask (1994)' },
    {
        message: 'Je suis trop vieux pour ces conneries',
        userFullName: "L'Arme fatale (1987)",
    },
    {
        message:
            'J’ai rencontré trois gabardines qui attendaient un train. Dans les gabardines se trouvaient trois hommes. Dans ces hommes se trouvent trois balles.',
        userFullName: 'Il était une fois dans l’Ouest (1968)',
    },
    {
        message:
            'Vous savez, moi je ne crois pas qu’il y ait de bonne ou de mauvaise situation. Moi, si je devais résumer ma vie aujourd’hui avec vous, je dirais que c’est d’abord des rencontres…',
        userFullName: 'Astérix et Obélix : Mission Cléopâtre (2002)',
    },
    {
        message: 'On se serait shooté à la vitamine C si cela avait été illégal…',
        userFullName: 'Trainspotting (1996)',
    },
    {
        message:
            'Si vous n’aimez pas la mer… Si vous n’aimez pas la montagne… Si vous n’aimez pas la ville… Allez vous faire foutre !',
        userFullName: 'À bout de souffle (1960)',
    },
    {
        message: 'Avant, je me disais que ma vie était une tragédie. Je me rends compte que c’est une comédie.',
        userFullName: 'Joker (2019)',
    },
    {
        message:
            'Dis moi Patrick à quoi ça sert ce truc là ? - À quoi ça sert ? À rien, il est con celui-là, c’est de l’art…',
        userFullName: 'La vérité si je mens ! (1997)',
    },
    {
        message: 'J’ignorais que tu savais piloter un avion. - Piloter, oui. Atterrir, non.',
        userFullName: 'Indiana Jones et la Dernière Croisade (1989)',
    },
    {
        message: 'La meilleure amie d’un garçon est sa mère.',
        userFullName: 'Psychose (1960)',
    },
    {
        message: 'Arrêtez ! Ou je tire une balle dans la tête à la main !',
        userFullName: 'La Tour Montparnasse infernale (2001)',
    },
    { message: 'Pas de bras, pas de chocolat', userFullName: 'Intouchables (2011)' },
    {
        message: 'Il nous faudrait un bateau plus gros.',
        userFullName: 'Les Dents de la mer (1975)',
    },
    {
        message:
            'Je suis dans une merde internationale, je suis poursuivi, on peut pas rester ici, y a trop de suspense !',
        userFullName: 'Chouchou (2003)',
    },
    {
        message: 'C’était Farès ? C’est effarant !',
        userFullName: 'Les Aventures de Rabbi Jacob (1973)',
    },
    { message: 'I want my scalps !', userFullName: 'Inglourious Basterds (2009)' },
    {
        message: 'Quand on parle pognon, à partir d’un certain chiffre, tout le monde écoute.',
        userFullName: 'Le Pacha (1968)',
    },
    {
        message: 'Il y avait moi, c’est-à-dire Alex et mes trois droogies, c’est-à-dire Pete, Georgie et Dim.',
        userFullName: 'Orange mécanique (1971)',
    },
    {
        message: 'J’vais mettre la viande dans le torchon.',
        userFullName: 'La vie est un long fleuve tranquille (1988)',
    },
    { message: 'Il ne peut en rester qu’un', userFullName: 'Highlander (1986)' },
    { message: 'C’est OKKKKKKKK !', userFullName: 'Les Visiteurs (1993)' },
    {
        message: 'C’est la belle qui a tué la bête.',
        userFullName: 'King Kong (1933)',
    },
    {
        message: 'L’ennemi est dangereux Maverick, mais toi, t’es pire que l’ennemi... tu es dangereux et con !',
        userFullName: 'Top Gun (1986)',
    },
    {
        message: 'Il s’appelle Juste Leblanc',
        userFullName: 'Le Dîner de cons (1998)',
    },
    {
        message: 'Alors… On n’attend pas Patrick ?',
        userFullName: 'Camping (2006)',
    },
    {
        message: 'Tu as déjà vu un monsieur tout nu ?',
        userFullName: "Y a-t-il un pilote dans l'avion ? (1980)",
    },
    {
        message: 'Pour survivre à la guerre, il faut devenir la guerre.',
        userFullName: 'Rambo 2 (1985)',
    },
    { message: 'C’est à moi que tu parles', userFullName: 'Taxi Driver (1976)' },
    {
        message: 'Joyeux anniversaire Jésus',
        userFullName: 'Full Metal Jacket (1987)',
    },
    {
        message: 'Je vais lui faire une offre qu’il ne pourra pas refuser',
        userFullName: 'Le Parrain (1972)',
    },
    { message: 'Je suis Iron Man', userFullName: 'Iron Man (2008)' },
    { message: "I'll be back", userFullName: 'Terminator (1984)' },
    { message: 'Coucou, chérie !', userFullName: 'Shining (1980)' },
    {
        message: 'Vous voulez un whisky ? - Oh, juste un doigt. - Vous voulez pas un whisky d’abord ?',
        userFullName: 'La Cité de la peur (1994)',
    },
    { message: 'La cuillère n’existe pas.', userFullName: 'Matrix (1999)' },
    {
        message: 'Antoine Doinel, Antoine Doinel, Antoine Doinel…',
        userFullName: 'Baisers volés (1968)',
    },
    { message: 'T’as mordu la ligne', userFullName: 'The Big Lebowski (1998)' },
    { message: 'Mooooaaaaahhhh', userFullName: 'Austin Powers (1997)' },
    {
        message:
            'Tu vois, le monde se divise en deux catégories : ceux qui ont un pistolet chargé et ceux qui creusent. Toi tu creuses.',
        userFullName: 'Le Bon, la Brute et le Truand (1966)',
    },
    { message: 'Bad Mother Fucker', userFullName: 'Pulp Fiction (1994)' },
    {
        message:
            'Vous avez de la pâte ? Vous avez du sucre ? Avec la pâte, vous faites une crêpe et vous mettez du sucre dessus !',
        userFullName: 'Les Bronzés font du ski (1979)',
    },
    { message: 'Adrienne !', userFullName: 'Rocky (1976)' },
    {
        message: 'Je t’aime - Je sais',
        userFullName: 'Star Wars : L’Empire contre-attaque (1980)',
    },
    {
        message: 'Vous ne passerez pas !',
        userFullName: 'Le Seigneur des anneaux : La Communauté de l’anneau (2001)',
    },
    {
        message: 'Gamin ! Reviens gamin c’était pour rire !',
        userFullName: 'C’est arrivé près de chez vous (1992)',
    },
    {
        message: 'Mais c’est d’la merde !',
        userFullName: 'Le Père Noël est une ordure (1982)',
    },
    {
        message: 'J’adore l’odeur du napalm au petit matin',
        userFullName: 'Apocalypse Now (1979)',
    },
    {
        message: 'J’m’appelle Bernie Noël, j’ai 29 ans bientôt 32.',
        userFullName: 'Bernie (1996)',
    },
    {
        message: 'Je vois des gens qui sont morts',
        userFullName: 'Le Sixième Sens (1999)',
    },
    {
        message: 'Je suis un homme ! - Eh bien... personne n’est parfait',
        userFullName: 'Certains l’aiment chaud (1959)',
    },
    {
        message: 'Il faut que ce soit green ok ?',
        userFullName: 'Le Cinquième Élément (1997)',
    },
    {
        message: 'La différence entre toi et moi, c’est que moi, j’ai la classe.',
        userFullName: 'Men in Black (1997)',
    },
    {
        message: 'Tu n’es pas seulement un lâche, tu es un traître, comme ta petite taille le laissait deviner.',
        userFullName: 'OSS 117 : Le Caire, nid d’espions (2006)',
    },
    {
        message: 'On ne se perche pas dans un camion',
        userFullName: 'Dumb and Dumber (1994)',
    },
    { message: "It's alive ! It's alive !", userFullName: 'Frankenstein (1931)' },
    {
        message:
            'Voici vos noms : Mr. Brown, Mr. White, Mr. Blonde, Mr. Blue, Mr. Orange et Mr. Pink. - Hey ! Pourquoi c’est moi Mr Pink ?',
        userFullName: 'Reservoir Dogs (1992)',
    },
    {
        message: 'Insulte-moi en allemand, vas-y',
        userFullName: '99 francs (2007)',
    },
    {
        message: 'J’ai dégusté son foie avec des fèves au beurre, et un excellent chianti.',
        userFullName: 'Le Silence des agneaux (1991)',
    },
    { message: 'Rosebud', userFullName: 'Citizen Kane (1941)' },
    {
        message: 'Yippie-ki-yay, motherfucker !',
        userFullName: 'Piège de cristal (1988)',
    },
    {
        message: 'Dites bonjour à mon petit copain',
        userFullName: 'Scarface (1983)',
    },
    {
        message: 'Mais qui est Keyser Söze ?',
        userFullName: 'Usual Suspects (1994)',
    },
    {
        message: 'J’aime ces petits moments de calme avant la tempête.',
        userFullName: 'Léon (1994)',
    },
    { message: 'Attica ! Attica !', userFullName: 'Un après-midi de chien (1975)' },
    {
        message: 'Vers l’infini et au-delà !',
        userFullName: 'Toy Story (1995)',
    },
    {
        message: 'Qu’est-ce qu’il y a dans ce paquet ?',
        userFullName: 'Seven (1995)',
    },
    {
        message: 'Quel est ton film d’horreur préféré ?',
        userFullName: 'Scream (1996)',
    },
    {
        message: 'Nous venons en paix.',
        userFullName: 'Mars Attacks ! (1996)',
    },
    {
        message: 'Elle est moche, elle est gentille mais elle est moche. Alors que toi t’es moche, puis t’es con',
        userFullName: 'Les Trois Frères (1997)',
    },
    {
        message: 'Mon précieux…',
        userFullName: 'Le Seigneur des anneaux : Les Deux Tours (2003)',
    },
    {
        message: 'Je suis l’aigle de la route !',
        userFullName: 'Mad Max (1979)',
    },
    {
        message: 'Je ne suis pas un animal ! Je suis un être humain. Je suis un homme',
        userFullName: 'Elephant Man (1980)',
    },
    { message: 'Nom de Zeus !', userFullName: 'Retour vers le futur II (1985)' },
    {
        message: "I'm gonna kill Bill",
        userFullName: 'Kill Bill Vol. 2 (2004)',
    },
    { message: 'Force et honneur', userFullName: 'Gladiator (2000)' },
    {
        message: 'As-tu jamais dansé avec le diable au clair de lune ?',
        userFullName: 'Batman (1989)',
    },
    {
        message: 'T’endors pas, c’est l’heure de mourir.',
        userFullName: 'Blade Runner (1982)',
    },
    {
        message: 'Vous n’avez pas dit le mot magique !',
        userFullName: 'Jurassic Park (1993)',
    },
    { message: 'Ça pue !', userFullName: 'Pinot simple flic (1984)' },
    {
        message: 'T’en as trop pris mon vieux',
        userFullName: 'Las Vegas Parano (1998)',
    },
    {
        message: 'La première règle du Fight Club est : il est interdit de parler du Fight Club.',
        userFullName: 'Fight Club (1999)',
    },
    {
        message: 'Si je te dis t’es tendue, t’es tendue ! C’est pas à toi de dire je ne suis pas tendue !',
        userFullName: 'Dikkenek (2006)',
    },
    {
        message: 'Houston, on a un problème',
        userFullName: 'Apollo 13 (1995)',
    },
    {
        message: 'Ils peuvent prendre nos vies, mais jamais… notre liberté',
        userFullName: 'Braveheart (1995)',
    },
    {
        message: 'Il ne sait pas se servir des trois coquillages !',
        userFullName: 'Demolition Man (1993)',
    },
    {
        message: 'E.T. téléphone maison.',
        userFullName: 'E.T. l’extraterrestre (1982)',
    },
    { message: 'Je t’aime Choco', userFullName: 'Les Goonies (1985)' },
    {
        message: 'Si j’aurais su, j’aurais pas venu.',
        userFullName: 'La Guerre des boutons (1962)',
    },
    {
        message: 'Je fais une fête chez moi ce soir. Ça te dirait de... de pas venir ?',
        userFullName: 'Brice de Nice (2005)',
    },
    {
        message: 'Je suis le maître du monde !',
        userFullName: 'Titanic (1997)',
    },
    {
        message: 'On laisse pas bébé dans un coin. Suis moi !',
        userFullName: 'Dirty Dancing (1987)',
    },
    {
        message: 'Mais dis-donc, on n’est quand même pas venu pour beurrer des sandwichs !',
        userFullName: 'Les Tontons flingueurs (1963)',
    },
    {
        message: 'Ça va être tout noir ! - Ta gueule !',
        userFullName: 'RRRrrrr !!! (2004)',
    },
    {
        message:
            'La vérité c’est comme une couverture trop petite. Tu peux tirer dessus de tous les côtés, tu auras toujours les pieds froids.',
        userFullName: 'Le Cercle des poètes disparus (1989)',
    },
    {
        message:
            'On dit que nous perdons tous 21 grammes au moment précis de notre mort. Le poids de cinq pièces de monnaie.',
        userFullName: '21 Grammes (2003)',
    },
    {
        message: 'Mon vélo, mes chaussures... et puis quoi maintenant ?',
        userFullName: 'La Grande Vadrouille (1966)',
    },
    {
        message: 'De tous les bars de toutes les villes du monde, il a fallu qu’elle entre dans le mien',
        userFullName: 'Casablanca (1942)',
    },
    {
        message: 'Je suis désolé Dave. Je crains de ne pas pouvoir faire ça.',
        userFullName: '2001 : L’Odyssée de l’espace (1968)',
    },
    {
        message: 'Mais j’étais pas en sirène, j’étais en siroi ! C’est pas pareil...',
        userFullName: 'Zoolander (2001)',
    },
    {
        message: 'Ça sent le taureau, ici !',
        userFullName: 'Mais qui a tué Pamela Rose ? (2003)',
    },
    {
        message: 'Tu es un sorcier, Harry !',
        userFullName: 'Harry Potter à l’école des sorciers (2001)',
    },
    {
        message: 'Beetlejuice ! Beetlejuice ! Beetlejuice !',
        userFullName: 'Beetlejuice (1988)',
    },
    {
        message: 'Why so serious ?',
        userFullName: 'The Dark Knight (2008)',
    },
    {
        message: 'I Like The Way You Die, Boy',
        userFullName: 'Django Unchained (2012)',
    },
    {
        message: 'On n’est pas bien là ? - Si. - Paisible ? À la fraîche ?',
        userFullName: 'Les Valseuses (1974)',
    },
    {
        message: 'Kiss my ass ! - D’accord, on fait comme ça !',
        userFullName: 'OSS 117 : Rio ne répond plus (2009)',
    },
    {
        message: 'Oh, and in case I don’t see you… Good afternoon, good evening and good night',
        userFullName: 'The Truman Show (1998)',
    },
    {
        message: 'Y’a plus personne sur Twitter ! Ceux qui restent, ils ne font que parler de pain de mie...',
        userFullName: 'Problemos (2017)',
    },
    {
        message:
            'C’est l’histoire d’un homme qui tombe d’un immeuble de 50 étages... Mais l’important, c’est pas la chute. C’est l’atterrissage.',
        userFullName: 'La Haine (1995)',
    },
    {
        message: 'Cadeau d’anniversaire de moi à moi ! Oh ! Comment me remercier ?',
        userFullName: 'Kuzco, l’empereur mégalo (2000)',
    },
    {
        message: 'Au nom du Père, du Fils, et du sans Esprit...',
        userFullName: 'Quatre mariages et un enterrement (1994)',
    },
    {
        message: 'Les ogres c’est comme les oignons. - Quoi ça pue ? - Non, ça a des couches.',
        userFullName: 'Shrek (2001)',
    },
    {
        message: 'Qui te paie !',
        userFullName: 'Jerry Maguire (1996)',
    },
    {
        message: 'Tu comprends pas ! J’aurais pu avoir de la classe, j’aurais pu être un champion.',
        userFullName: 'Sur les quais (1954)',
    },
    {
        message: 'Donnez-moi la même chose qu’elle',
        userFullName: 'Quand Harry rencontre Sally (1989)',
    },
    {
        message: 'Atmosphère ! Atmosphère ! Est-ce que j’ai une gueule d’atmosphère ?',
        userFullName: 'Hôtel du Nord (1938)',
    },
    {
        message: 'Hasta la vista, baby',
        userFullName: 'Terminator 2 : Le Jugement dernier (1991)',
    },
];
